"use strict";

exports.__esModule = true;
exports.LogbookPanelWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _LogbookPanelElement = require("./LogbookPanelElement");
var _LogbookPanelFields = require("./LogbookPanelFields");
var _LogbookPanelHeader = require("./LogbookPanelHeader");
var _LogbookPanelThumbnail = require("./LogbookPanelThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LogbookPanelWidget = exports.LogbookPanelWidget = {
  name: "LogbookPanel",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "LogbookPanelWidget.label",
    defaultMessage: "Logbook"
  }),
  icon: "properties",
  group: _widgetGroups.DIGITAL_LOG_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "LogbookPanel",
      props: Object.assign({
        width: 300,
        height: 300
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: [],
  requiresProps: ["x", "y", "width", "height", "devices", "interval"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 200,
      min: 256,
      max: 3840
    },
    height: {
      "default": 256,
      min: 256,
      max: 2160
    }
  },
  components: {
    Header: _LogbookPanelHeader.LogbookPanelHeader,
    Element: _LogbookPanelElement.LogbookPanelElement,
    Fields: _LogbookPanelFields.LogbookPanelFields,
    Thumbnail: _LogbookPanelThumbnail.LogbookPanelThumbnail
  }
};